package com.milta.core.localization.translations.en

import com.milta.core.localization.WebHistoriqueStrings

internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "Delivery route history",
    periodLabel = "Period",
    periodLastEightDays = "Last 8 days",
    periodSingleDate = "Specific date",
    periodRange = "Date range",
    rangeFromLabel = "From",
    rangeToLabel = "To",
    driverFilterLabel = "Driver",
    driverFilterAllOption = "All drivers",
    historySearchLabel = "Search",
    historySearchPlaceholder = "Search driver, recipient, address, reason…",
    columnDate = "Date",
    columnDriver = "Driver",
    columnTotalDeliveries = "Total deliveries",
    columnDelivered = "Delivered",
    columnFailed = "Failed",
    viewProofsAction = "View proofs",
    emptyHistoryMessage = "No routes found for this period.",
    errorInvalidPeriod = "The selected period is not valid.",
    screenBTitle = "Delivery proof history",
    routeOfLabel = "Route of",
    totalDeliveriesLabel = "deliveries",
    deliveredLabel = "delivered",
    failedLabel = "failed",
    backToHistoryAction = "Route history",
    statusDeliveredBadge = "Delivered",
    statusFailedBadge = "Failed",
    viewReasonAction = "View reason",
    hideReasonAction = "Hide reason",
    photoPlaceholderAlt = "No photo available",
    photoAlt = "Delivery proof",
    emptyProofsMessage = "No delivery proof available for this route.",
    proofsSearchLabel = "Search delivery",
    proofsSearchPlaceholder = "Search recipient, address, reason…",
    paginationPrevious = "Previous",
    paginationNext = "Next",
)
